import React from 'react'
import ReactDOM from 'react-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import 'antd/dist/antd.css'
import "bootstrap/dist/css/bootstrap.min.css"
import { ThemeProvider } from 'styled-components'
import { theme } from './design-system'

import "react-datepicker/dist/react-datepicker.css";
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import promise from 'redux-promise'
import reducers from './reducers'

import { getCookieByName, CutieflyCheckVersion } from './utils'

import PublicViews from './views/Public'
import FullAppViews from './views/AppViews'
import SellerViews from "./views/Seller/Views"

CutieflyCheckVersion()

const access = getCookieByName("access")
const role = getCookieByName("role")
const store = applyMiddleware(promise)(createStore)(reducers)

import clientAPI from './api';

window.clientAPI = clientAPI;

if (access) {
    if (role) {
        if (parseInt(role) === 3) {
            ReactDOM.render(<Provider store={store}>
                <ThemeProvider theme={theme}>
                    <FullAppViews />
                    <h1>role accountand</h1>
                    <ToastContainer />
                </ThemeProvider>
            </Provider>,
                document.getElementById('root')
            );
        } else if (parseInt(role) === 2) {
            ReactDOM.render(<ThemeProvider theme={theme}><SellerViews /></ThemeProvider>,
                document.getElementById('root')
            );
        } else {
            ReactDOM.render(<Provider store={store}>
                <ThemeProvider theme={theme}>
                    <div id="awesome-snackbar"></div>
                    <FullAppViews />
                    <ToastContainer />
                </ThemeProvider>
            </Provider>,
                document.getElementById('root')
            );
        }
    } else {
        ReactDOM.render(<Provider store={store}>
            <ThemeProvider theme={theme}>
                <FullAppViews />
                <ToastContainer />
            </ThemeProvider>
        </Provider>,
            document.getElementById('root')
        );
    }
} else {
    ReactDOM.render(<Provider store={store}>
        <ThemeProvider theme={theme}>
            <div id="awesome-snackbar"></div>
            <PublicViews />
        </ThemeProvider>
    </Provider>,
        document.getElementById('root')
    );
}



// WEBPACK FOOTER //
// ./src/index.js